// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CMZ8AeyF6kpkZ7l2PhGy{display:flex;flex-direction:column;gap:32px}.RfNAPvfiWE8BwnSV6CJh{flex:1}.SY0jcCEwyI0qpS0TUy02{align-self:flex-start}", "",{"version":3,"sources":["webpack://./src/pages/cp/conversations/channel/facebookMessenger/visibility/index.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,qBAAA,CACA,QAAA,CAGJ,sBACI,MAAA,CAGJ,sBACI,qBAAA","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.select {\n    flex: 1;\n}\n\n.submitButton {\n    align-self: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "CMZ8AeyF6kpkZ7l2PhGy",
	"select": "RfNAPvfiWE8BwnSV6CJh",
	"submitButton": "SY0jcCEwyI0qpS0TUy02"
};
export default ___CSS_LOADER_EXPORT___;
